export const NEARBY_TRAINER_COUNT = 'nearby_trainer_count';
export const INCLUDE_NEARBY_TRAINER_COUNT = 'include_nearby_trainer_count';
export const FORCE_SEO_LANDING = 'force_seo_landing';
export const SEARCH_ORIGIN_CENTERLAT = 'search_origin_centerlat';
export const SEARCH_ORIGIN_CENTERLNG = 'search_origin_centerlng';
